import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

type TimelineStepType = 'start' | 'end' | 'middle' | 'none';

const Timeline = styled.div<{ type: TimelineStepType }>`
  line-height: 1.5em;
  font-size: 14px;
  transition: all 0.4s ease;
  position: relative;
  flex: 1 1 auto;

  &:before {
    content: '';
    position: absolute;
    border-left: 8px solid #b21f00;
    left: 2.5em;
    ${({ type }) =>
      type === 'start' &&
      css`
        top: 2em;
        bottom: 0em;
      `}

    ${({ type }) =>
      type === 'end' &&
      css`
        top: 0em;
        bottom: 2em;
      `}

    ${({ type }) =>
      (type === 'middle' || type === 'none') &&
      css`
        top: 0em;
        bottom: 0em;
      `}
  }
`;

const TimelineEntry = styled.div<{ title: string; type: TimelineStepType }>`
  position: relative;
  flex: 1 1 auto;

  //- number indicator
  &:before {
    content: '${(props) => props.title}';
    position: absolute;
    color: white;
    align-items: center;
    justify-content: center;
    width: 2.5em;
    height: 2.5em;
    left: 1.5em;
    top: 1.5em;
    font-weight: bold;
    background-color: #b21f00;
    border-radius: 50%;

    ${({ type }) =>
      type === 'none' &&
      css`
        display: none;
      `}

    ${({ type }) =>
      type !== 'none' &&
      css`
        display: flex;
      `}
  }
`;

export interface PlanProgressTimelineStepProps {
  stepNumber?: string;
  stepType?: 'start' | 'end' | 'middle' | 'none';
}

const PlanProgressTimelineStep: FC<PlanProgressTimelineStepProps> = ({
  stepNumber = '',
  stepType = 'none',
}) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    maxWidth="80px"
    minWidth="80px"
  >
    <Timeline type={stepType}>
      <TimelineEntry title={stepNumber} type={stepType} />
    </Timeline>
  </Box>
);

PlanProgressTimelineStep.defaultProps = {
  stepNumber: '',
  stepType: 'none',
};

export default PlanProgressTimelineStep;
